
import React from 'react'
import './UserMenu.scss'
import { faUser } from '@fortawesome/pro-solid-svg-icons'
import { NavLink } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
export default function UserMenu() {
    return (
        <>
            <div className='icon-wrapper'>
                <NavLink to="profile" className="userProfileIcon"><FontAwesomeIcon icon={faUser} /></NavLink>

            </div>
        </>
    )
}
